import React, { useMemo, useState, useEffect } from "react";
import {
  FaTimes,
  FaUser,
  FaSave,
  FaSearch,
  FaCheckCircle,
} from "react-icons/fa";
import styles from "./AccessModal.module.css";

export default function AccessModal({
  route,
  allUsers,
  accessByRoute,
  updateAccess,
  updatedRoutes,
  onClose,
  setAccessByRoute, // важно! получаем setter из родителя
}) {
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);

  // локальная копия доступа
  const [localAccess, setLocalAccess] = useState([]);

  useEffect(() => {
    // при открытии — копируем текущее состояние
    setLocalAccess(accessByRoute[route.id] || []);
  }, [accessByRoute, route.id]);

  const toggleLocalAccess = (userId) => {
    setLocalAccess((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const usersByLetter = useMemo(() => {
    const groups = {};
    allUsers
      .filter((u) =>
        `${u.username} ${u.firstName}`.toLowerCase().includes(search.toLowerCase())
      )
      .forEach((u) => {
        const letter = (u.username?.[0] || "?").toUpperCase();
        if (!groups[letter]) groups[letter] = [];
        groups[letter].push(u);
      });
    return Object.fromEntries(
      Object.entries(groups).sort(([a], [b]) => a.localeCompare(b))
    );
  }, [allUsers, search]);

    const handleSave = async () => {
    setSaving(true);

    // сначала обновляем состояние родителя, и ждём его применения
    await new Promise((resolve) => {
        setAccessByRoute((prev) => {
        const updated = { ...prev, [route.id]: localAccess };
        resolve(updated);
        return updated;
        });
    });

    // теперь точно передаём в updateAccess актуальные данные
    await updateAccess(route.id, localAccess);

    setSaving(false);
    onClose();
    };

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modal} ${saving ? styles.saving : ""}`}>
        <div className={styles.header}>
          <div>
            <h3>Настройка доступа</h3>
            <p className={styles.routeInfo}>
              <FaCheckCircle className={styles.iconAccent} /> Маршрут №
              {route.route_number} ({route.route_date})
            </p>
          </div>
          <button onClick={onClose} className={styles.closeBtn} title="Закрыть">
            <FaTimes />
          </button>
        </div>

        <div className={styles.searchBox}>
          <FaSearch className={styles.icon} />
          <input
            type="text"
            placeholder="Поиск пользователя..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className={styles.userList}>
          {Object.entries(usersByLetter).map(([letter, users]) => (
            <div key={letter} className={styles.letterBlock}>
              <h4 className={styles.letter}>{letter}</h4>
              <div className={styles.letterUsers}>
                {users.map((u) => {
                  const hasAccess = localAccess.includes(u.id);
                  return (
                    <div
                      key={u.id}
                      className={`${styles.userItem} ${
                        hasAccess ? styles.hasAccess : ""
                      }`}
                      onClick={() => toggleLocalAccess(u.id)}
                      title={
                        hasAccess
                          ? `Убрать доступ у ${u.username}`
                          : `Дать доступ ${u.username}`
                      }
                    >
                      <FaUser className={hasAccess ? styles.iconActive : ""} />
                      <span>
                        {u.username} {u.firstName}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <button
          className={`${styles.saveBtn} ${
            updatedRoutes[route.id] ? styles.saved : ""
          }`}
          onClick={handleSave}
          disabled={saving}
        >
          <FaSave />
          {saving
            ? "Сохраняю..."
            : updatedRoutes[route.id]
            ? "Сохранено"
            : "Сохранить"}
        </button>
      </div>
    </div>
  );
}
